/**
 * Withdraw Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var WithdrawMethodModel = require('portlets/cashier/withdraw/withdraw.method.model');
    var CashierMethodCollection = require('portlets/cashier/cashier.method.collection');

    module.exports = CashierMethodCollection.extend({

        model: WithdrawMethodModel,

        paymentMethod: 'withdraw',

        parse: function(response) {
            var methods = CashierMethodCollection.prototype.parse.call(this, response);

            this.addPredefinedOptions(methods);

            return methods;
        },

        addPredefinedOptions: function(methods) {
            methods.forEach(function(method) {
                if (method.accountFields && method.accountFields.field.length) {
                    method.accountFields.field.forEach(function(field) {
                        var hasTwoFields;

                        if (!field.predefinedFieldValues || !field.predefinedFieldValues.predefinedFieldValue.length) {
                            return;
                        }

                        method.hasPredefinedValues = true;

                        hasTwoFields = Boolean(field.predefinedFieldValues.predefinedFieldValue[0].label2);

                        if (hasTwoFields) {
                            field.predefinedValuesType = 'TWO_LEVEL';

                            this.addTwoLevelOptions(field, field.predefinedFieldValues.predefinedFieldValue);
                        } else {
                            field.predefinedValuesType = 'ONE_LEVEL';
                        }
                    }.bind(this));

                    method._selectedAccount = method.account && method.account.length && method.account[0];
                }
            }.bind(this));
        },

        addTwoLevelOptions: function(field, predefinedFieldValues) {
            var shopsByCity = {};
            var uniqueCities = _.uniq(predefinedFieldValues.map(function(value) {
                return value.label2;
            })).sort();

            uniqueCities.forEach(function(city) {
                shopsByCity[city] = predefinedFieldValues
                    .filter(function(value) {
                        return value.label2 === city;
                    })
                    .map(function(value) {
                        return {
                            label: value.label1,
                            value: value.value
                        };
                    });
            });

            field.uniqueCities = uniqueCities;
            field.shopsByCity = shopsByCity;
        }
    });
});
